module.exports = __webpack_public_path__ + "img/wechattu4.ad8f6d59.png";